var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVector1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2304,
    height: 2211,
    viewBox: "0 0 2304 2211",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1235.25 167L0 308.5V2210.5H2304V0L2175.39 35.5H2066.72L2006.4 0L1925.65 35.5L1824.96 50.5L1696.35 17.5L1534.84 106H1474.52L1383.8 78.5L1235.25 167Z",
    fill: "url(#paint0_linear_83_85)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_83_85",
    x1: 1151.5,
    y1: -28.5,
    x2: 1164.54,
    y2: 191.495,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7B9CAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CAC2CE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector1);
export default __webpack_public_path__ + "static/media/Vector1.a3ad89fb759d0aec4b8df49bc7d5edda.svg";
export { ForwardRef as ReactComponent };